// Recorded content-provenance receipt bundles for the Clarion Overview credential.
//
// Two REAL sealed content credentials produced by
// scripts/generate-newsroom-receipts.ts (deterministic multi-step gig +
// in-process witness), inlined at build like the other demos' data.ts. Both
// share one agent identity and are built on the same allowlisted sources,
// differing only in the editor sign-off (and thus the verdict):
//   story-signed-off — a human editor signed off -> conformant: true
//   story-auto        — auto-published, no sign-off -> conformant: false
import storySignedOff from "../../../demo-artifacts-newsroom/receipts/story-signed-off/bundle.json";
import storyAuto from "../../../demo-artifacts-newsroom/receipts/story-auto/bundle.json";

export type Bundle = Record<string, string>;

// Keyed by the bundleId each credential scenario references.
export const NEWSROOM_BUNDLES: Record<string, Bundle> = {
  "story-signed-off": storySignedOff as Bundle,
  "story-auto": storyAuto as Bundle
};
